var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('keep-alive',{attrs:{"include":"index"}},[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e(),(_vm.isShow)?_c('myfooter'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }